import type { DropdownBaseListItem } from "app/pages/sales-intelligence/modules/technology/types/dropdown";
import {
    compareNamesAsc,
    getMatchedSubString,
    stringMatchesSearchTerm,
} from "app/pages/sales-intelligence/sub-modules/advanced-search/helpers/common";
import type {
    WithNamesMatchType,
    WithSecondaryName,
} from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";

export function dropdownNameMatchesSearchTerm(searchTerm: string) {
    return function <T extends DropdownBaseListItem<string> & Partial<WithSecondaryName>>(item: T) {
        if (searchTerm.length === 0) {
            return true;
        }

        const nameMatches = stringMatchesSearchTerm(item.name, searchTerm);

        let secondaryNameMatches = false;

        if (typeof item.secondaryName !== "undefined") {
            secondaryNameMatches = stringMatchesSearchTerm(item.secondaryName, searchTerm);
        }

        return nameMatches || secondaryNameMatches;
    };
}

export function toDropdownItemWithMatchedSubStrings(searchTerm: string) {
    return function <T extends DropdownBaseListItem<string> & Partial<WithSecondaryName>>(
        item: T,
    ): T & WithNamesMatchType & { isSelected?: boolean } {
        if (searchTerm.length === 0) {
            return item;
        }

        const nameMatch = getMatchedSubString(searchTerm, item.name);
        const secondaryNameMatch = getMatchedSubString(searchTerm, item.secondaryName);

        return {
            ...item,
            nameMatch,
            secondaryNameMatch,
        };
    };
}

export function dropdownCompareByPrimaryNameMatch<
    T extends DropdownBaseListItem<string> & Pick<WithNamesMatchType, "nameMatch">,
>(a: T, b: T) {
    if (a.nameMatch && !b.nameMatch) {
        return -1;
    }

    return compareNamesAsc(a, b);
}
